<template>
    <nav class="navbar navbar-fixed-top" style="height:85px">
         <div class="container-fluid">
             <div class="navbar-brand">
                <router-link to="/dashboard" v-if="toggleSidebarTheme == ''">
                    <img src="../../../assets/logo6.png" alt="Lucid Logo" class="img-responsive logo" style="width:50px;height:60px">
                </router-link>
                <link href="https://fonts.googleapis.com/css2?family=Lato:wght@400&display=swap" rel="stylesheet">
                <span style="margin-top:13px;margin-left:-9px;color:#27305f; display:inline-block; font-family: 'Lato', sans-serif; font-size: 20px;">FaceScreen</span>             
             </div>                                                         
             
             <div class="navbar-right">              
                 <div id="navbar-menu">
                     <ul class="nav navbar-nav">
                         <li>
                             <button @click.prevent="logout" class="icon-menu d-flex align-items-center justify-content-center" style="background: none; border: none; cursor: pointer;">
                                <i class="icon-login"></i> 
                                <span class="sign-out-text mx-2" style="color:#004ead">Log Out</span>
                             </button>
                         </li>
                     </ul>
                 </div>
             </div>
         </div>
     </nav>
 </template>
 
 <script>
 export default {
     name: 'HeaderComponent',
     methods: {
         toggleSideMenu() {
             document.body.classList.toggle('offcanvas-active');
         },
         logout() {
             localStorage.removeItem('userJWtoken');
            this.$router.push({ path: '/authentication/page-login' })
            .catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    console.error(err);
                }
            });
         }
     },
     data() {
         return {
             dropActive: false,
             notificationMenu: false,
             toggleSidebarClass: false,
             toggleSidebarTheme: '',
         };
     },
     directives: {
         'click-outside': {
             bind(el, binding) {
                 const bubble = binding.modifiers.bubble;
                 const handler = (e) => {
                     if (bubble || (!el.contains(e.target) && el !== e.target)) {
                         binding.value(e);
                     }
                 };
                 el.__vueClickOutside__ = handler;
                 document.addEventListener('click', handler);
             },
         },
     },
     mounted() {
         this.emitter.on('theme', (theme) => {
             this.toggleSidebarTheme = theme;
         });
     }
 };
 </script>
 
 <style scoped>
 </style>
 